module.exports = __webpack_public_path__ + "static/media/checked-icon2.a1deacff.svg";